export const selectServiceTreeServices = (state) => state.serviceTree.services;
export const selectServiceTreeSelected = (state) => state.serviceTree.selected;
export const selectServiceTreeOpened = (state) => state.serviceTree.opened;

export const selectMobilityTreeServices = (state) =>
  state.mobilityTree.services;
export const selectMobilityTreeSelected = (state) =>
  state.mobilityTree.selected;
export const selectMobilityTreeOpened = (state) => state.mobilityTree.opened;
